import Styles
  from './ProgressStatusList.module.scss'
import { PropsWithChildren } from 'react'

export const ProgressStatusList = ({ children }: PropsWithChildren) => {
  return (
    <ul className={Styles.progressList}>
      {children}
    </ul>
  )
}
